import axios from 'axios'
import {router} from './routes'
import auth from './services/auth'
import store from './store/index'
import messageDialog from './components/message-dialog.vue'

const cfg = {
  API_BASE: '/api'
};

function run() {
  configAxios();
}

function configAxios() {
  axios.defaults.baseURL = cfg.API_BASE;
  axios.defaults.timeout = 10000000;
  axios.interceptors.response.use(function (res) {
    let mmStatus = res.data && res.data.status && res.data.status.code || undefined;

    // Verifica se o servidor retornou 200.
    let statusOK = res.status >= 200 && res.status <= 299;
    if (!statusOK) return Promise.reject(res);

    switch (mmStatus) {
      // Verifica caso de cookie inválido.
      case 9000:
        res.status = 400;

        //essa chamada sempre é feita ao carregar o header, evita que direcione para o login
        if(res.config.url.indexOf("getListChildAccount")>=0)
          return res;

        auth.logout().then(() => {
          router.push({name: 'login', query: {sessionExpired:true}});
        });
        return res
        break;

      // Verifica se a requisição foi aceita para processamento
      case 0:
      case undefined:
        return res;

      // Verifica caso de outro erro retornado pelo backend. Neste caso
      // simula um erro 4xx
      default:
      
        res.status = 400;
        return Promise.reject(res)
    }

  }, function (error) {
    if (error && error.response) {
      const raw = error.response.data || {};
      let normalized = raw;
      if (typeof raw.status === 'number') {
        const message = raw.message || 'Erro';
        normalized = Object.assign({}, raw, {
          status: { code: raw.status, message: message },
          message: message
        });
      }
      return Promise.reject(Object.assign({}, error.response, { data: normalized }));
    }
    return Promise.reject(error);
  })
}

export default {
  ...cfg,
  run
}





// WEBPACK FOOTER //
// ./src/config.js